export const CURRENT_STATE_LABELS: Record<number, string> = {
  0: 'Tech fixes',
  1: 'Duplicado',
  2: 'OK conjunto',
  3: 'Revisar dirección',
  4: 'Número mal',
  5: 'No contesta',
  6: 'Vendido',
  7: 'Incompleto',
  8: 'Desistió',
  9: 'Arrendado',
  10: 'Fuera de la zona',
  11: 'Descartado',
  12: 'No aplica',
  13: 'Completo',
  14: 'Suficiente',
  15: 'Descartado por precio',
  16: 'Descartado por antiguedad',
  17: 'Descartado por inmobiliaria',
  18: 'Descartado por información',
  20: 'No gestionado',
  21: 'No interesado',
  22: 'No contesta',
  23: 'Volver a llamar',
  24: 'Interesado',
  25: 'No contactable',
  26: 'Vendido',
  27: 'Cita agendada',
  28: 'Visita efectuada',
  29: 'Por agendar',
  30: 'Oferta rechazada',
  31: 'Esperando respuesta',
  32: 'Abandonó',
  33: 'Descartado por precio elevado',
  34: 'Descartado por precio bajo',
  35: 'Inmobiliaria',
  36: 'No hay suficientes datos para comparar',
  38: 'Descartado por inmueble',
  39: 'Incompleto desde Web',
  40: 'Web Scraping',
  41: 'Sin apartamentos',
  42: 'Venta',
  43: 'Publicado',
  44: 'Posible Duplicado',
  45: 'En negociación',
  46: 'Revisión comité',
  47: 'Acuerdo firma',
  48: 'Cierre',
  49: 'Fuera de la zona Ventanero',
  50: 'Dirección revisada',
  51: 'Descartado por dirección',
  52: 'Agente Externo',
  53: 'Vendido Habi',
  54: 'Avalúo',
  55: 'Descartado por último piso sin ascensor',
  56: 'Descartado por inmueble no habi',
  57: 'No corresponde inmueble',
  58: 'Pendiente validar dirección',
  59: 'No contesta coordinador',
  60: 'Confirmación de datos',
  61: 'Sin zona mediana',
  62: 'Contacto MKT',
  63: 'Sin pricing inicial',
  64: 'Descartado por antiguedad y precio vis',
  65: 'Habimetro sin gestión',
  66: 'Desistió negocio buyers',
  67: 'Separado',
  68: 'Backbone',
  69: 'Zona en exploración',
  70: 'Descartado por gravamen',
  71: 'Descarte por estrato',
  72: 'Descartado por fuente',
  73: 'Sin precio automático',
};

export const getCurrentStateLabel = (state: number | string): string => {
  const key = Number(state);
  return CURRENT_STATE_LABELS[key] ?? String(state);
};
